'use client';

import React from 'react';
import ProductListCMS, {ProductListCMSProps} from 'components/commercetools-ui/organisms/product/product-list-cms';
import { TasticProps } from 'frontastic/tastics/types';
import InstantSearch from 'components/HOC/InstantSearch';
import LocalizedIndex from 'providers/algolia/localized-index';


const ProductlistSliderTastic  = ({ data }: TasticProps<ProductListCMSProps>) => {
    return (
        <InstantSearch>
            <LocalizedIndex type="products">
                <ProductListCMS data={data.data.dataSource} />
            </LocalizedIndex>
        </InstantSearch>
    );

};

export default ProductlistSliderTastic;

